export default {
  'inviteRebate.tabDeposit': '充值返佣',
  'inviteRebate.tabBet': '投注返佣',
  'inviteRebate.tabWinLoss': '输赢返佣',

  'inviteRebate.colSettleDate': '结算日期',
  'inviteRebate.colSettleMonth': '结算月份',
  'inviteRebate.colInviter': '邀请人',
  'inviteRebate.colCoin': '币种',
  'inviteRebate.colHitTier': '命中档位',
  'inviteRebate.tierN': '档 {n}',
  'inviteRebate.level1': '一级',
  'inviteRebate.level2': '二级',
  'inviteRebate.level3': '三级',
  'inviteRebate.levelN': '{n}级',
  'inviteRebate.colDepositBase': '充值基数',
  'inviteRebate.colBetBase': '有效投注基数',
  'inviteRebate.colWinLossBase': '净输赢基数',
  'inviteRebate.colCashAmount': '返佣金额',
  'inviteRebate.colCashAmountTotal': '合计',
  'inviteRebate.colCumulativeCash': '累计返佣',
  'inviteRebate.colExtraAward': '附加奖励',
  'inviteRebate.colAwardStatus': '状态',
  'inviteRebate.awardStatus1': '待发放',
  'inviteRebate.awardStatus2': '已发放',
  'inviteRebate.awardStatus3': '已拒绝',
  'inviteRebate.colUpdateTime': '更新时间',
  'inviteRebate.colOperation': '操作',
  'inviteRebate.colGameType': '场馆类型',
  'inviteRebate.calcDetail': '计算详情',
  'inviteRebate.calcDetailTitle': '返佣计算详情',
  'inviteRebate.all': '全部',
  'inviteRebate.search': '搜索',
  'inviteRebate.reset': '重置',
  'inviteRebate.export': '导出',
  'inviteRebate.exportEmpty': '暂无可导出的数据',
  'inviteRebate.operationFail': '操作失败',

  'inviteRebate.colFriendAccount': '好友账号',
  'inviteRebate.colLevel': '层级',
  'inviteRebate.colBaseAmount': '基数',
  'inviteRebate.colRatio': '比例',
  'inviteRebate.colContributedAmount': '贡献返佣',
  'inviteRebate.colFriendDetail': '好友明细',
  'inviteRebate.ngrFriendDetailHint': '仅显示期内有活动（本人 GGR / 领取优惠 / 积分兑换任一非 0）的好友；逐人金额各自四舍五入，合计可能与本期佣金相差 0.01',
  'inviteRebate.colRemark': '备注',
  'inviteRebate.remarkPlaceholder': '运营在确定发放/拒绝时可填写备注（200字以内）',
  'inviteRebate.extraAward': '附加奖励',
  'inviteRebate.extraPoint': '积分 {n}',

  'inviteRebate.actionConfirmIssue': '确定发放',
  'inviteRebate.actionReject': '拒绝',
  'inviteRebate.confirmIssueTip': '确定发放本笔返佣？现金将立即到账。',
  'inviteRebate.confirmIssueSuccess': '发放成功',
  'inviteRebate.rejectIssueTip': '确定拒绝本笔返佣？拒绝后将不再发放。',
  'inviteRebate.rejectIssueSuccess': '已拒绝',
  'inviteRebate.tabNgr': 'NGR 返佣',
  'inviteRebate.colSettlePeriod': '结算期次',
  'inviteRebate.settlePeriodTip': '按期次起始日筛选（每月 1 日 / 16 日）',
  'inviteRebate.colNgrBase': 'NGR 基数',
  'inviteRebate.colPeriodCommission': '本期佣金',
  'inviteRebate.colCarryIn': '上期结转',
  'inviteRebate.carryInFrom': '来自 {{period}}',
  'inviteRebate.colPayable': '应发金额',
  'inviteRebate.awardStatus4': '无应发·结转下期',
  'inviteRebate.noPayableNote': '应发 ≤ 0，不发放，负值结转下期抵扣',
  'inviteRebate.colFriendGgr': '本人 GGR',
  'inviteRebate.colFriendBonus': '领取优惠',
  'inviteRebate.colFriendPointExchange': '积分兑换',
};
